/**
 * Chunks an array into pieces
 * @param array
 * @param length
 * @returns {Array}
 */
function chunk(array, length) {
	let chunks = [];
	let currentChunk;

	array.forEach((item, i) => {
		if (i % length === 0) {
			if (currentChunk) {
				chunks.push(currentChunk);
			}

			currentChunk = [];
		}

		currentChunk.push(item);
	});

	chunks.push(currentChunk);

	return chunks;
}

function arrayEquals(array1, array2) {
	if (array1.length !== array2.length) {
		return false;
	}

	for (let i = 0; i < array1.lenght; i++) {
		if (array1[i] !== array2[i]) {
			return false;
		}
	}

	return true;
}

function isArray(arrayLike) {
	return typeof arrayLike.push === "function";
}

function avg(array, key = null) {
	const {queryObject} = require("helpers/object");

	return array.length === 0 ?
		0.0 :
		array.reduce((acc, element) => acc + (key == null ? element : queryObject(element, key, 0.0)), 0.0) / array.length;
}

function arrayGroup(array, callback) {
	return array.reduce((groups, element) => {
		const group = callback(element);

		if (typeof group === "string") {
			if (groups[group] == undefined) {
				groups[group] = [];
			}

			groups[group].push(element);
		}

		return groups;

	}, {});
}

module.exports = {
	chunk,
	arrayEquals,
	isArray,
	avg,
	arrayGroup
};


// WEBPACK FOOTER //
// ./resources/js/helpers/array.js